import React, { memo } from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function FinalCTA() {
  return <section className="bg-black py-24 px-4 text-white text-center" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-10 leading-tight" data-id="element-75">
          Photographing your dog can be easier than you think
        </h2>

        <div className="font-sans text-xl md:text-2xl text-gray-300 mb-12" data-id="element-76">
          <p className="mb-6" data-id="element-77">You do not need more random photo tips.</p>
          <p className="mb-6 text-soft-gold font-medium" data-id="element-78">
            You need a simple system that helps you:
          </p>

          <ul className="space-y-4 max-w-xl mx-auto text-left inline-block" data-id="element-79">
            <li className="flex items-center" data-id="element-80">
              <span className="text-green-400 mr-3" data-id="element-81">✓</span> understand what
              works
            </li>
            <li className="flex items-center" data-id="element-82">
              <span className="text-green-400 mr-3" data-id="element-83">✓</span> capture your dog's
              personality
            </li>
            <li className="flex items-center" data-id="element-84">
              <span className="text-green-400 mr-3" data-id="element-85">✓</span> create better
              memories
            </li>
            <li className="flex items-center" data-id="element-86">
              <span className="text-green-400 mr-3" data-id="element-87">✓</span> stop relying on
              luck
            </li>
          </ul>
        </div>

        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-xl md:text-2xl py-6 px-10 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 uppercase mb-10 text-center" data-id="element-88">
          👉 GET INSTANT ACCESS TO THE PAWFECT SHOT MEGAPACK
        </button>

        <p className="font-serif text-2xl md:text-3xl text-soft-gold italic" data-id="element-89">
          Because your dog deserves more than random snapshots.
        </p>
      </div>
    </section>;
}